import * as React from "react";
import { PillSelect } from "./PillSelect";
import { SelectOption } from "./types";

interface PillSingleSelectProps {
  value: string | null;
  onUpdate: (val: string | null) => void;
  options: SelectOption[];
  labeledBy?: string;
}

export const PillSingleSelect = ({
  value,
  onUpdate,
  ...props
}: PillSingleSelectProps) => {
  return (
    <PillSelect
      value={value ? [value] : []}
      onUpdate={(values) => onUpdate(values.length > 0 ? values[0] : null)}
      allowMultiple={false}
      {...props}
    ></PillSelect>
  );
};
